import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let PageLoading = class PageLoading extends Vue {
    constructor() {
        super(...arguments);
        this.delayValue = false;
    }
    mounted() {
        this.loadingToggle();
    }
    watchLoading() {
        setTimeout(() => {
            this.delayValue = this.value;
        }, this.delay);
        this.loadingToggle();
    }
    loadingToggle() {
        const pageLoading = this.$refs.pageLoading;
        if (pageLoading && pageLoading.parentElement) {
            pageLoading.parentElement.classList.toggle('page-loading-wrap', this.value);
        }
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], PageLoading.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({ default: true })
], PageLoading.prototype, "shade", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], PageLoading.prototype, "loadingText", void 0);
tslib_1.__decorate([
    Prop({ default: '#FFFFFF' })
], PageLoading.prototype, "shadeColor", void 0);
tslib_1.__decorate([
    Prop({ default: 0.85 })
], PageLoading.prototype, "shadeOpacity", void 0);
tslib_1.__decorate([
    Prop({ default: 0 })
], PageLoading.prototype, "delay", void 0);
tslib_1.__decorate([
    Watch('value', { immediate: true })
], PageLoading.prototype, "watchLoading", null);
PageLoading = tslib_1.__decorate([
    Component({
        name: 'page-loading'
    })
], PageLoading);
export default PageLoading;
